"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTimelineContent = exports.StyledTimeline = exports.StyledTag = exports.TagContainer = exports.TimelineContentContainer = exports.CustomFooter = exports.EventContainer = exports.StyledTimelineConnector = exports.StyledTimelineDot = void 0;
var lab_1 = require("@mui/lab");
var Box_1 = __importDefault(require("../Box"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Tag_1 = __importDefault(require("../Tag"));
var colors_1 = require("../ThemeProvider/colors");
exports.StyledTimelineDot = (0, styled_1.default)(lab_1.TimelineDot)({
    backgroundColor: colors_1.tannerGray[400],
    boxShadow: 'none',
});
exports.StyledTimelineConnector = (0, styled_1.default)(lab_1.TimelineConnector)({
    backgroundColor: colors_1.tannerGray[400],
});
exports.EventContainer = (0, styled_1.default)(Box_1.default)({
    justifySelf: 'space-between',
});
exports.CustomFooter = (0, styled_1.default)(Box_1.default)({
    width: '100%',
});
exports.TimelineContentContainer = (0, styled_1.default)(Box_1.default, {
    shouldForwardProp: function (prop) {
        return prop !== 'shouldHaveBorderBottom' && prop !== 'variant';
    },
})(function (_a) {
    var shouldHaveBorderBottom = _a.shouldHaveBorderBottom, variant = _a.variant;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'space-between',
        paddingBottom: shouldHaveBorderBottom ? '8px' : '16px',
        borderBottom: variant === 'simple'
            ? 'none'
            : shouldHaveBorderBottom
                ? "1px solid ".concat(colors_1.tannerGray[200])
                : 'none',
    });
});
exports.TagContainer = (0, styled_1.default)('div')(function (_a) {
    var position = _a.position;
    return ({
        display: 'flex',
        gap: '4px',
        flexWrap: 'wrap',
        margin: '8px 0',
        maxWidth: '775px',
        justifyContent: position === 'right' ? 'flex-start' : 'flex-end',
    });
});
exports.StyledTag = (0, styled_1.default)(Tag_1.default)({
    width: 'fit-content',
    maxWidth: '250px',
});
exports.StyledTimeline = (0, styled_1.default)(lab_1.Timeline)((_a = {},
    _a["& .".concat(lab_1.timelineOppositeContentClasses.root)] = { flex: 0.2 },
    _a));
exports.StyledTimelineContent = (0, styled_1.default)(lab_1.TimelineContent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiTypography-root.MuiTypography-body1.MuiTimelineContent-root.MuiTimelineContent-positionRight {\n    padding-bottom: 0px;\n  }\n"], ["\n  &.MuiTypography-root.MuiTypography-body1.MuiTimelineContent-root.MuiTimelineContent-positionRight {\n    padding-bottom: 0px;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=styles.js.map